export const CalculatorOptions = [
    "Audi Multitronic",
    "Bosch",
    "Campi",
    "Caterpillar",
    "Chrysler",
    "Delco",
    "Delphi",
    "Denso",
    "EFI",
    "GMPT",
    "Hella",
    "Hitachi",
    "Kefico",
    "Keihin",
    "Lucas",
    "Marelli",
    "Mitsubishi",
    "Moroic",
    "Motorola/Cummins",
    "Phoenix",
    "SISU",
    "Saab",
    "Sagem",
    "Shindengen",
    "Siemens/Continental",
    "TRW",
    "Temic",
    "Transtron",
    "VDO",
    "Valeo",
    "Visteon",
] as const;

export type CalculatorOption = (typeof CalculatorOptions)[number];
